import { Icons } from "@pankod/refine-antd";
import { RefineKbar } from "@pankod/refine-kbar";

import { ToggleContainer } from "./styled";

const { LeftOutlined } = Icons;

export const OffLayoutArea = () => {
    return (
        <ToggleContainer>
            <RefineKbar />
            <LeftOutlined />
            <a href="https://flora24.online">
                Switch to <br />
                <strong>Shop</strong>
            </a>
        </ToggleContainer>
    );
};
